const CALLOUT_MIN = 21;
const CALLOUT_MAX = 39;

function randomCalloutNumber(exclude) {
  let number;
  do {
    number = Math.floor(Math.random() * (CALLOUT_MAX - CALLOUT_MIN + 1)) + CALLOUT_MIN;
  } while (exclude?.has(number));
  return number;
}

document.addEventListener('alpine:init', () => {
  Alpine.data('dynamicCallOut', () => ({
    dynamicNumber: 0,
    optionNumbers: new Map(),

    init() {
      this.dynamicNumber = randomCalloutNumber();
      this.initializeOptionNumbers();

      this.$watch('option1', () => this.updateNumber());
      this.$watch('option2', () => this.updateNumber());
      this.$watch('option3', () => this.updateNumber());
      this.$watch('current_variant', () => this.updateNumber());
    },

    initializeOptionNumbers() {
      const usedNumbers = new Set();

      const option1Values = this.getOptionValues('option1');
      const option2Values = this.getOptionValues('option2');
      const option3Values = this.getOptionValues('option3');

      option1Values.forEach(val1 => {
        option2Values.forEach(val2 => {
          option3Values.forEach(val3 => {
            const key = `${val1}|${val2}|${val3}`;
            const number = randomCalloutNumber(usedNumbers);
            usedNumbers.add(number);
            this.optionNumbers.set(key, number);
          });
        });
      });
    },

    getOptionValues(optionName) {
      const optionElements = document.querySelectorAll(`[name="${optionName}"], [data-option="${optionName}"]`);
      if (optionElements.length > 0) {
        return Array.from(optionElements).map(el => el.value || el.textContent);
      }
      return ['default'];
    },

    updateNumber() {
      const currentOption1 = this.option1 || 'default';
      const currentOption2 = this.option2 || 'default';
      const currentOption3 = this.option3 || 'default';
      const key = `${currentOption1}|${currentOption2}|${currentOption3}`;

      if (this.optionNumbers.has(key)) {
        this.dynamicNumber = this.optionNumbers.get(key);
      } else {
        this.dynamicNumber = randomCalloutNumber();
        this.optionNumbers.set(key, this.dynamicNumber);
      }
    }
  }));
});